import './Input.scss';

const Input = ({ type, placeholder, ...etc }) => (
  <input type={type || 'text'} placeholder={placeholder || ''} {...etc} />
);

export default Input;
